import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 5 }
const _hoisted_5 = { key: 6 }

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Img = _resolveComponent("Img")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('chat-modal-container'))
  }, [
    _createCommentVNode(" MODAL COMPONENT "),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('chat-modal-backdrop ')
		+ ' ' + ((_ctx.messageSettings && _ctx.messageSettings.style && _ctx.messageSettings.style == 'slide') ? _ctx.getClass('slide-fade') : '')
		+ ' ' + ((_ctx.messageSettings && _ctx.messageSettings.style && _ctx.messageSettings.style == 'center') ? _ctx.getClass('modal-center') : ''))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClass('chat-modal ')),
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "Consent Modal",
        "aria-describedby": "modalDescription",
        ref: "consent_modal"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getClass('chat-modal-header'))
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { "aria-hidden": "true" }, " ", -1 /* HOISTED */)),
          _withDirectives(_createElementVNode("button", {
            type: "button",
            class: _normalizeClass(_ctx.getClass('btn-modal-close')),
            "aria-label": "Close modal",
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            title: "Close modal"
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("span", { "aria-hidden": "true" }, "×", -1 /* HOISTED */)
          ]), 2 /* CLASS */), [
            [_vShow, _ctx.messageSettings && _ctx.messageSettings.enableCloseIcon != null ? !!_ctx.messageSettings.enableCloseIcon : true]
          ])
        ], 2 /* CLASS */),
        _createElementVNode("section", {
          class: _normalizeClass(_ctx.getClass('chat-modal-body')),
          id: "modalDescription"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (component, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (component.type=='text')
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    innerHTML: _ctx.decodeTags(component.content)
                  }, null, 8 /* PROPS */, _hoisted_1))
                : (component.type=='html')
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      innerHTML: component.content
                    }, null, 8 /* PROPS */, _hoisted_2))
                  : (component.type=='markdown')
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 2,
                        innerHTML: _ctx.marked(component.content)
                      }, null, 8 /* PROPS */, _hoisted_3))
                    : (component.type=='button' || component.type=='link')
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 3,
                          component: component,
                          messageContentsettings: _ctx.messageContentsettings
                        }, null, 8 /* PROPS */, ["component", "messageContentsettings"]))
                      : (component.type=='image')
                        ? (_openBlock(), _createBlock(_component_Img, {
                            key: 4,
                            component: component
                          }, null, 8 /* PROPS */, ["component"]))
                        : (component.type=='line')
                          ? (_openBlock(), _createElementBlock("hr", _hoisted_4))
                          : (component.type=='break')
                            ? (_openBlock(), _createElementBlock("br", _hoisted_5))
                            : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 2 /* CLASS */)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}